import { RootState } from "../../redux-store";

export const selectFeature = (feature: string) => (state: RootState) => {
  return state.features[feature]?.enabled || false;
};
